import React, { useCallback, useState, useEffect } from 'react';
import './Diseno.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../Components/url';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import { guardarSiteConfig } from '../../Components/siteConfig';
import { monedasTienda } from '../../Components/moneda';

export default function Diseno() {
    const [colorPrincipal, setColorPrincipal] = useState('#780576');
    const [logoPreview, setLogoPreview] = useState(null);
    const [faviconPreview, setFaviconPreview] = useState(null);
    const [tituloPestana, setTituloPestana] = useState('');
    const [nombreTienda, setNombreTienda] = useState('');
    const [monedaTienda, setMonedaTienda] = useState('$');
    const [showWhatsappButton, setShowWhatsappButton] = useState(true);
    const [deliveryPageContent, setDeliveryPageContent] = useState('');
    const [returnsPageContent, setReturnsPageContent] = useState('');
    const [termsPageContent, setTermsPageContent] = useState('');
    const [mensaje, setMensaje] = useState('');

    const aplicarColorPrincipal = useCallback((color) => {
        const nextColor = color || '#780576';
        setColorPrincipal(nextColor);
        document.documentElement.style.setProperty('--color1', nextColor);

        const themeColor = document.querySelector("meta[name='theme-color']");
        if (themeColor) {
            themeColor.setAttribute('content', nextColor);
        }
    }, []);

    const cargarConfiguracion = useCallback(async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php`);
            const data = await response.json();
            if (data.config) {
                guardarSiteConfig(data.config);
                if (data.config.colorPrincipal) aplicarColorPrincipal(data.config.colorPrincipal);
                if (data.config.logo) setLogoPreview(data.config.logo);
                if (data.config.favicon) setFaviconPreview(data.config.favicon);
                if (data.config.tituloPestana) setTituloPestana(data.config.tituloPestana);
                if (data.config.nombreTienda) setNombreTienda(data.config.nombreTienda);
                if (monedasTienda.includes(data.config.moneda)) setMonedaTienda(data.config.moneda);
                setShowWhatsappButton(data.config.showWhatsappButton === undefined ? true : Boolean(Number(data.config.showWhatsappButton)));
                setDeliveryPageContent(data.config.deliveryPageContent || '');
                setReturnsPageContent(data.config.returnsPageContent || '');
                setTermsPageContent(data.config.termsPageContent || '');
            }
        } catch (error) {
            console.error('Error al cargar configuración:', error);
        }
    }, [aplicarColorPrincipal]);

    useEffect(() => {
        cargarConfiguracion();
    }, [cargarConfiguracion]);

    const handleImageChange = (event, setPreview) => {
        const file = event.target.files[0];
        if (file) {
            const previewURL = URL.createObjectURL(file);
            setPreview(previewURL);
        }
    };

    const guardarCambios = async (e) => {
        e.preventDefault();
        setMensaje('Guardando...');
        
        const form = document.getElementById("disenoForm");
        const formData = new FormData(form);

        try {
            const response = await fetch(`${baseURL}/configPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                if (data.config) {
                    guardarSiteConfig(data.config);
                    aplicarColorPrincipal(data.config.colorPrincipal);
                    if (data.config.logo) setLogoPreview(data.config.logo);
                    if (data.config.favicon) setFaviconPreview(data.config.favicon);
                    if (data.config.tituloPestana) setTituloPestana(data.config.tituloPestana);
                    if (data.config.nombreTienda) setNombreTienda(data.config.nombreTienda);
                    if (monedasTienda.includes(data.config.moneda)) setMonedaTienda(data.config.moneda);
                    setShowWhatsappButton(data.config.showWhatsappButton === undefined ? true : Boolean(Number(data.config.showWhatsappButton)));
                    setDeliveryPageContent(data.config.deliveryPageContent || '');
                    setReturnsPageContent(data.config.returnsPageContent || '');
                    setTermsPageContent(data.config.termsPageContent || '');
                }
                toast.success(data.mensaje);
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <div className='containerDiseno'>
                        <div className='disenoHeader'>
                            <h2>Diseño de la Tienda</h2>
                            <p>Personaliza el aspecto visual de tu sitio web</p>
                        </div>

                        <form id="disenoForm" onSubmit={guardarCambios} className='formDiseno'>
                            <div className='flexGrapDiseno'>
                                <fieldset className='fieldsetDiseno'>
                                    <legend>Color Principal</legend>
                                    <p className='descDiseno'>Elige el color que destacará en botones y detalles.</p>
                                    <div className='colorPickerWrapper'>
                                        <input
                                            type="color"
                                            id="colorPrincipal"
                                            name="colorPrincipal"
                                            value={colorPrincipal}
                                            onChange={(e) => aplicarColorPrincipal(e.target.value)}
                                            className='inputColor'
                                        />
                                        <span className='colorHex'>{colorPrincipal}</span>
                                    </div>
                                </fieldset>

                                <fieldset className='fieldsetDiseno'>
                                    <legend>Identidad de la Tienda</legend>
                                    <p className='descDiseno'>Aquí puedes definir por separado el logo, el icono de la pestaña y el texto que verá el usuario en la pestaña del navegador.</p>

                                    <div className='brandingGridDiseno'>
                                        <div className='brandingItemDiseno'>
                                            <h4>Logo</h4>
                                            <p className='descDiseno'>Sube tu logo principal. Tamaño recomendado: 1000 x 1000 px, PNG transparente o con fondo limpio.</p>
                                            <label htmlFor="logo" className='logoLabel'>
                                                <input
                                                    type="file"
                                                    id="logo"
                                                    name="logo"
                                                    accept="image/*"
                                                    onChange={(event) => handleImageChange(event, setLogoPreview)}
                                                />
                                            </label>
                                            {logoPreview &&
                                                <div className='previewLogo'>
                                                    <h4>Vista previa:</h4>
                                                    <img src={logoPreview} alt="Vista previa del logo" />
                                                </div>
                                            }
                                        </div>

                                        <div className='brandingItemDiseno'>
                                            <h4>Icono de la pestaña</h4>
                                            <p className='descDiseno'>Elige una imagen específica para la pestaña del navegador. Tamaño recomendado: 512 x 512 px. Para app/PWA, ideal 1024 x 1024 px.</p>
                                            <label htmlFor="favicon" className='logoLabel'>
                                                <input
                                                    type="file"
                                                    id="favicon"
                                                    name="favicon"
                                                    accept="image/*,.ico"
                                                    onChange={(event) => handleImageChange(event, setFaviconPreview)}
                                                />
                                            </label>
                                            {faviconPreview &&
                                                <div className='previewLogo previewFavicon'>
                                                    <h4>Vista previa:</h4>
                                                    <img src={faviconPreview} alt="Vista previa del icono de pestaña" />
                                                </div>
                                            }
                                        </div>

                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Nombre de la tienda</h4>
                                            <p className='descDiseno'>Este encabezado se mostrará como nombre visible de tu tienda en el sitio.</p>
                                            <input
                                                type="text"
                                                id="nombreTienda"
                                                name="nombreTienda"
                                                className='inputTextoDiseno'
                                                placeholder='Ejemplo: Boutique Maria'
                                                value={nombreTienda}
                                                onChange={(e) => setNombreTienda(e.target.value)}
                                            />
                                        </div>

                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Título de la pestaña</h4>
                                            <p className='descDiseno'>Este texto aparecerá junto al icono en la pestaña del navegador.</p>
                                            <input
                                                type="text"
                                                id="tituloPestana"
                                                name="tituloPestana"
                                                className='inputTextoDiseno'
                                                placeholder='Ejemplo: Mi tienda online'
                                                value={tituloPestana}
                                                onChange={(e) => setTituloPestana(e.target.value)}
                                            />
                                        </div>

                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Botón de WhatsApp</h4>
                                            <p className='descDiseno'>Elige si el botón flotante de WhatsApp se muestra en la tienda.</p>
                                            <label className='checkboxDiseno'>
                                                <input
                                                    type="checkbox"
                                                    id="showWhatsappButton"
                                                    name="showWhatsappButton"
                                                    checked={showWhatsappButton}
                                                    onChange={(e) => setShowWhatsappButton(e.target.checked)}
                                                />
                                                <span>Mostrar botón flotante de WhatsApp</span>
                                            </label>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className='fieldsetDiseno'>
                                    <legend>Moneda de la tienda</legend>
                                    <p className='descDiseno'>Define la moneda que se usará para todos los precios, descuentos, carrito y pedidos.</p>
                                    <div className='currencyBlockDiseno'>
                                        <label htmlFor="moneda">Moneda</label>
                                        <select
                                            id="moneda"
                                            name="moneda"
                                            className='inputTextoDiseno'
                                            value={monedaTienda}
                                            onChange={(e) => setMonedaTienda(e.target.value)}
                                        >
                                            {monedasTienda.map((option) => (
                                                <option key={option} value={option}>{option}</option>
                                            ))}
                                        </select>
                                    </div>
                                </fieldset>

                                <fieldset className='fieldsetDiseno'>
                                    <legend>Contenido de la tienda</legend>
                                    <p className='descDiseno'>Edita el texto público de entregas, devoluciones y términos. La página de soporte usa tus datos de contacto y WhatsApp.</p>

                                    <div className='brandingGridDiseno'>
                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Entregas</h4>
                                            <textarea
                                                name="deliveryPageContent"
                                                className='textareaDiseno'
                                                rows="5"
                                                placeholder='Escribe la información de entregas de tu tienda.'
                                                value={deliveryPageContent}
                                                onChange={(e) => setDeliveryPageContent(e.target.value)}
                                            />
                                        </div>
                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Devoluciones</h4>
                                            <textarea
                                                name="returnsPageContent"
                                                className='textareaDiseno'
                                                rows="5"
                                                placeholder='Escribe la política de cambios o devoluciones.'
                                                value={returnsPageContent}
                                                onChange={(e) => setReturnsPageContent(e.target.value)}
                                            />
                                        </div>
                                        <div className='brandingItemDiseno brandingItemFull'>
                                            <h4>Términos y condiciones</h4>
                                            <textarea
                                                name="termsPageContent"
                                                className='textareaDiseno'
                                                rows="5"
                                                placeholder='Escribe los términos y condiciones de tu tienda.'
                                                value={termsPageContent}
                                                onChange={(e) => setTermsPageContent(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div className='actionsDiseno'>
                                {mensaje ? (
                                    <button type="button" className='btnLoadingDiseno' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <button type="submit" className='btnSaveDiseno'>
                                        Guardar Cambios
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
